import PropTypes from "prop-types";
import "../../style/LoadingSpinner.css";

const LoadingSpinner = ({
  size = 40,
  fullPage = false,
  message = null,
  variant = "default", // default, dots, pulse
}) => {
  // calculate sizes
  const spinnerSize = size;
  const strokeWidth = Math.max(3, size / 10);

  const spinner = (
    <div
      className={`spinner-enhanced spinner-enhanced--${variant}`}
      style={{ width: spinnerSize, height: spinnerSize }}
    >
      {variant === "default" && (
        <svg viewBox="0 0 50 50" className="spinner-svg">
          <circle
            className="spinner-track"
            cx="25"
            cy="25"
            r="20"
            fill="none"
            strokeWidth={strokeWidth}
          />
          <circle
            className="spinner-progress"
            cx="25"
            cy="25"
            r="20"
            fill="none"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
          />
        </svg>
      )}
      {variant === "dots" && (
        <div className="spinner-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      )}
      {variant === "pulse" && (
        <div className="spinner-pulse">
          <span></span>
          <span></span>
        </div>
      )}
    </div>
  );

  if (fullPage) {
    return (
      <div className="spinner-fullpage">
        <div className="spinner-fullpage__content">
          {spinner}
          {message && <p className="spinner-message">{message}</p>}
        </div>
      </div>
    );
  }

  return spinner;
};

LoadingSpinner.propTypes = {
  size: PropTypes.number,
  fullPage: PropTypes.bool,
  message: PropTypes.string,
  variant: PropTypes.oneOf(["default", "dots", "pulse"]),
};

export default LoadingSpinner;

// Usage examples:
//
// 1. Inline spinner:
// <LoadingSpinner size={24} />
//
// 2. Full page loading:
// <LoadingSpinner fullPage message="Loading data..." />
//
// 3. Dots variant:
// <LoadingSpinner variant="dots" />
